import { FC, type JSX } from 'react';

import { useTranslation } from '@/i18n';
import AssigneeGroupedListedTimelogsControl from '@/ui/components/assigneeGroupedListedTimelogsControl/AssigneeGroupedListedTimelogsControl';
import { Helmet } from 'react-helmet';
import AuthenticatedPageWrapper from '../pageWrappers/authenticatedPageWrapper/AuthenticatedPageWrapper';
import './TimelogReportingPage.sass';

import { Routes } from '@/routes/RoutesConfig';
import { TimelogsRoles } from '@payaca/permissions/timelogs/timelogs.roles';

const TimelogReportingPage: FC = (): JSX.Element => {
  const translate = useTranslation();

  return (
    <>
      <Helmet title={translate('pages.timelogs.title')} />
      <AuthenticatedPageWrapper
        pageRouteId={Routes.TIMELOG_REPORTING}
        className="timelog-reporting-page"
        requiredRoles={[TimelogsRoles.ASSIGNEE_VIEWER]}
      >
        <div className="typography:prose">
          <h1 className="px-8 py-4">Timelog reporting</h1>
        </div>
        <div className="p-4">
          <AssigneeGroupedListedTimelogsControl />
        </div>
      </AuthenticatedPageWrapper>
    </>
  );
};

export default TimelogReportingPage;
